import {AUTH_ACTION_LOGIN, AUTH_ACTION_MY_INFO, AUTH_ACTION_LOGOUT} from './constants'; 
import {login, myInfo, signup, activate, resendKey, forgotPassword, buyElevator, changePass} from '../services/auth';

export const startLoginService = (body) => {
    return (dispatch, getState) => {
        return login({body})
            .then((response) => {
                // dispatch(loginUser(response.data))
                localStorage.setItem('authToken', response.data.token)
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                };
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                };
            })
    }
}

export const loginUser = (payload) => ({
    type: AUTH_ACTION_LOGIN,
    payload
});

export const startGetMyInfo = (userToken='') => {
    return (dispatch, getState) => {
        return myInfo({
            header: {
                Authorization: `Token ${userToken}`
            }
        })
        .then((response) => {
            dispatch(loginUser({token: userToken}))
            dispatch(getMyInfo(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            };
        })
    }
};

export const getMyInfo = (payload) => ({
    type: AUTH_ACTION_MY_INFO,
    payload
});

export const startLogoutUser = () => {
    return (dispatch, getState) => {
        localStorage.removeItem('authToken')
        dispatch(logoutUser())
    }
};

export const logoutUser = () => ({
    type: AUTH_ACTION_LOGOUT,
    payload: {}
});

export const startRegisterService = (body) => {
    return (dispatch, getState) => {
        return signup({body})
            .then((response) => {
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                };
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                };
            })
    }
}

export const startActivateService = (body) => {
    return (dispatch, getState) => {
        return activate({body})
            .then((response) => {
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                };
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                };
            })
    }
}

export const startResendCodeService = (body) => {
    return (dispatch, getState) => {
        return resendKey({body})
            .then((response) => {
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                };
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                };
            })
    }
}

export const startForgotPassService = (body) => {
    return (dispatch, getState) => {
        return forgotPassword({body})
            .then((response) => {
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                };
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                };
            })
    }
}

export const startBuyElevator = (amount=1) => {
    return (dispatch, getState) => {
        return buyElevator({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body: {amount}
        })
        .then((response) => {
            dispatch(buyElevatorAction(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            };
        })
    }
};

const buyElevatorAction = (payload) => ({
    type: AUTH_ACTION_MY_INFO,
    payload
});

export const startChangePass = (body={}) => {
    return (dispatch, getState) => {
        return changePass({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body
        })
        .then((response) => {
            // dispatch(buyElevatorAction(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            };
        })
    }
};